import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { Process } from '../../shared';
import { ReplaySubject } from 'rxjs';
import { IOversignTime } from '../IOversignTime';
import { LoggingService } from '../../shared/services/logging/logging.service';
import moment from 'moment';

@Component({
    selector: 'ef-oversign-time-presenter',
    templateUrl: './oversign-time-presenter.component.html',
    styleUrls: ['./oversign-time-presenter.component.scss'],
    standalone: false
})
export class OversignTimePresenterComponent implements OnInit {
    @Output() oversignUpdate = new EventEmitter<Array<IOversignTime>>();
    private OversignSubject = new ReplaySubject<Array<IOversignTime>>(1);
    private _oversigndata: Array<IOversignTime>;
    @Input() set oversignData(value: Array<IOversignTime>) {
        if (value && value.length >= 0) {
            this.log.verbose({
                type: 'OversignTimePresenterComponent:oversigndata:set',
                value
            });

            this._oversigndata = value;
            this.OversignSubject.next(value);
        }
    }
    get oversignData(): Array<IOversignTime> {
        return this._oversigndata;
    }

    public selectedOversignData: Array<IOversignTime> = [];

    constructor(@Inject(LoggingService) private log: LoggingService) {}

    ngOnInit() {}
    public oversignTimeClicked() {
        this.oversignUpdate.emit(this.selectedOversignData);
    }


}
